import React from 'react';
import PropTypes from 'prop-types';
import { customDateFormat } from 'helpers/dateFormat';
import Status from './components/Status';
import Properties from './components/Properties';
import CropSeasonsTags from './components/CropSeasonsTags';
import ViewLink from './components/ViewLink';

const TableRow = ({ submission, field }) => {
  switch (field) {
    case 'date':
      return (
        <div className="flex w-full justify-start">
          {customDateFormat(submission.date, 'MMM dd, yyyy h:mm aaaa')}
        </div>
      );
    case 'status':
      return (
        <div className="flex w-fit justify-start">
          <Status type={submission.status} />
        </div>
      );
    case 'taskCount':
      return <div className="text-left">{submission.taskCount}</div>;
    case 'cropSeasons':
      return <CropSeasonsTags cropSeasons={submission.cropSeasons} />;
    case 'dateRange':
      return (
        <div className="items-start">
          {customDateFormat(submission.startDate, 'MMM dd, yyyy')} -
          <br />
          {customDateFormat(submission.endDate, 'MMM dd, yyyy')}
        </div>
      );
    case 'propertiesCount':
      return (
        <Properties
          propertiesArea={submission.propertiesArea}
          propertiesCount={submission.propertiesCount}
          propertiesNames={submission.propertiesNames}
        />
      );
    default:
      return <ViewLink id={submission.id} />;
  }
};

TableRow.propTypes = {
  submission: PropTypes.shape({
    id: PropTypes.string,
    propertiesNames: PropTypes.arrayOf(PropTypes.string),
    propertiesArea: PropTypes.number,
    propertiesCount: PropTypes.number,
    taskCount: PropTypes.number,
    cropSeasons: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      })
    ),
    status: PropTypes.oneOf(['error', 'pending', 'in_progress', 'done']),
    date: PropTypes.instanceOf(Date),
    startDate: PropTypes.string,
    endDate: PropTypes.string
  }).isRequired,
  field: PropTypes.string.isRequired
};

export default TableRow;
